import { useState } from 'react'
import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { useSelector } from 'react-redux'
import { select } from '@/store'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors } from '@/styles'
import AgreeToTerms from '@/components/agree-to-terms'
import contractCreatedIcon from '../CustomContractCreate/modal/contract-created-icon.svg'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.red96};
  height: 112px;
  width: 100%;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 24px;
`
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  button {
    width: 50%;
    :last-child {
      margin-left: 5px;
    }
  }
`

const Title = styled.h5`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
`

const MissingUserTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey16};
  margin: 24px 0 0 0;
  text-align: left;
`

const ExternalUserModal = ({ contractId, user }) => {
  const { close } = useModalize()
  const { t } = useTranslation()
  const [agreed, setAgreed] = useState(false)
  const { contract } = useSelector(state =>
    select.contract.contractPackageInfo(state, { contractId })
  )

  const userName = `${user?.first_name} ${user?.last_name}`
  const address = contract?.building?.full_address

  return (
    <Container>
      <IconWrapper>{<img src={contractCreatedIcon} alt="icon" />}</IconWrapper>
      <TextWrapper>
        <Title>
          <Trans t={t} i18nKey="b.contract_signing_modal.title" userName={userName}>
            Welcome to liv.sign, {{ userName }}
          </Trans>
        </Title>
        <ContentWrapper>
          <MissingUserTitle>
            <Trans t={t} i18nKey="b.contract_signing_modal.address.title" address={address}>
              You have been invited to sign this document for the home at {{ address }}
            </Trans>
          </MissingUserTitle>
          <AgreeToTerms setAgreed={setAgreed} showAgeGate altStyle />
        </ContentWrapper>
        <ButtonWrapper>
          <Button theme="primary" onClick={close} disabled={!agreed}>
            {t('l.incomplete_modal.continue.text', 'Continue')}
          </Button>
        </ButtonWrapper>
      </TextWrapper>
    </Container>
  )
}

const showExternalUserModal = createModal(ExternalUserModal, { showClose: false, width: '498px' })

export default showExternalUserModal
